import App from "components/app/App";
import "rc-time-picker/assets/index.css";
import * as React from "react";
import { CookiesProvider } from "react-cookie";
import "react-day-picker/lib/style.css";
import * as ReactDOM from "react-dom";
import "react-toastify/dist/ReactToastify.css";
import "./assets/style/bootstrap.css";
import "./assets/style/global-styles.css";
import "./assets/style/isotope-table.css";
import "./assets/style/overrides/rc-time-picker.css";

// Main ReactDOM render!
ReactDOM.render(
  <CookiesProvider>
    <App />
  </CookiesProvider>,
  document.getElementById("root") as HTMLElement

);






// WEBPACK FOOTER //
// ./src/index.tsx